export const theme = {
  colors: {
    bgPrimary: '#0D0B1E',
    bgSecondary: '#1A1333',
    bgCard: 'rgba(26, 19, 51, 0.85)',
    pink: '#FF1493',
    pinkSoft: '#E91E8C',
    purple: '#9D4EDD',
    text: '#FFFFFF',
    textMuted: '#B8A9C9',
    success: '#7DCF4C',
    danger: '#FF4D6D',
    border: 'rgba(255, 20, 147, 0.25)',
    glow: '0 0 20px rgba(255, 20, 147, 0.35)',
  },
  fonts: {
    heading: "'Orbitron', sans-serif",
    body: "'Poppins', sans-serif",
  },
  radius: '12px',
};
